/**
 * 악덕알리미 공지사항 (/b/notices) — 카테고리 탭 + 목록, 항목을 누르면 본문을 펼친다
 * ($j.Pages.Devil.Notices / body data-page-name="Notices")
 */
export default class Notices {
    initialize() {
        const $root  = document.getElementById('notice-list');
        const $tabs  = document.getElementById('notice-tabs');
        let ALL = [];
        let curCat = '';

        // 탭 클릭 → 필터 갱신
        $tabs.addEventListener('click', e => {
            const $b = e.target.closest('.ntab');
            if (!$b) return;
            curCat = $b.getAttribute('data-cat') || '';
            $tabs.querySelectorAll('.ntab').forEach(t => t.classList.toggle('active', t === $b));
            renderList();
        });

        // 로드
        fetch('/b/ajax/notices')
            .then(r => r.json())
            .then(res => {
                if (!res || !res.result) {
                    $root.innerHTML = `<div class="nempty"><span class="ntxt">${escHtml((res && res.message) || '불러오기 실패')}</span></div>`;
                    return;
                }
                ALL = res.list || [];
                renderList();
            })
            .catch(() => { $root.innerHTML = `<div class="nempty"><span class="ntxt">네트워크 오류</span></div>`; });

        function renderList(){
            const fi = curCat ? ALL.filter(n => n.category === curCat) : ALL;
            // pinned 가 위로 (서버 정렬도 동일하지만 명시)
            const sorted = [...fi.filter(n => n.pinned), ...fi.filter(n => !n.pinned)];
            if (!sorted.length) {
                $root.innerHTML = `<div class="nitem-empty"><span class="ntxt">등록된 공지가 없습니다.</span></div>`;
                return;
            }
            $root.innerHTML = sorted.map(n => `
                <div class="nitem" data-num="${n.num}">
                    <div class="nmeta">
                        <span class="ncat">${n.category ? '[' + escHtml(n.category) + ']' : ''}</span>
                        <span class="ndate">${formatDate(n.created_at)}</span>
                    </div>
                    <div class="nhead">
                        ${n.pinned ? pinSvg() : ''}
                        <span class="ntitle">${escHtml(n.title)}</span>
                        ${n.is_new ? '<span class="nnew">NEW</span>' : ''}
                    </div>
                    <div class="nbody"></div>
                </div>
            `).join('');
            $root.querySelectorAll('.nitem').forEach(el => {
                el.addEventListener('click', () => toggleBody(el));
            });
        }

        function toggleBody(el){
            const $body = el.querySelector('.nbody');
            if ($body.style.display === 'block') { $body.style.display = 'none'; return; }
            if ($body.dataset.loaded === '1')    { $body.style.display = 'block'; return; }
            const num = el.getAttribute('data-num');
            fetch(`/b/ajax/notice/${num}`)
                .then(r => r.json())
                .then(res => {
                    if (!res || !res.result) {
                        $body.innerHTML = `<em>${escHtml((res && res.message) || '본문 불러오기 실패')}</em>`;
                    } else {
                        const cover = res.row.cover_url ? `<div><img src="${res.row.cover_url}" alt=""></div>` : '';
                        $body.innerHTML = cover + (res.row.body || '');
                    }
                    $body.dataset.loaded = '1';
                    $body.style.display = 'block';
                })
                .catch(() => { $body.innerHTML = '<em>네트워크 오류</em>'; $body.style.display = 'block'; });
        }

        function pinSvg(){
            return '<svg class="npin" width="14" height="14" viewBox="0 0 18 18" fill="none">'
                + '<path d="M9 2v7M6 9h6l-1 5H7l-1-5z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>'
                + '</svg>';
        }
        function formatDate(s){ if (!s) return ''; return String(s).slice(2,10).replace(/-/g,'-'); }// 26-03-10
        function escHtml(s){ return String(s==null?'':s).replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c])); }
    }
}
